<template>
    <div v-if="visible" v-bind:class="classes" @click="fadeBanner">
        {{ message }}
    </div>
</template>

<script>
    export default {
        name: 'MessageBanner',
        props: ['message', 'error', 'displayTime'],
        data() {
            return {
                visible: false,
                classes: ["messageBanner", "successBanner"],
                timeout: null
            }
        },
        watch: {
            message: function (newVal) {
                if (newVal) {
                    let typeClass = "successBanner";

                    if (this.error)
                        typeClass = "errorBanner";

                    this.classes.pop();
                    this.classes.push(typeClass);

                    if (this.displayTime > 0)
                        this.timeout = setTimeout(this.fadeBanner, this.displayTime);

                    this.visible = true;
                } // if
            }
        },
        methods: {
            fadeBanner: function () {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(this.hideBanner, 600);
                this.classes.unshift("fadeOut");
            },
            hideBanner: function () {
                this.classes.shift();
                clearTimeout(this.timeout);
                this.visible = false;
                this.$emit("banner-hidden");
            }
        }
    }
</script>

<style scoped>
    .messageBanner {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        text-align: center;
        font-size: 130%;
        font-weight: 600;
        position: fixed;
        top: 5%;
        left: 15%;
        right: 15%;
        padding: 12px 6px;
        color: white;
        border-radius: 8px;
        box-shadow: 2px 4px 4px #333;
        -webkit-animation-name: fadeIn;
        -webkit-animation-duration: 0.3s;
        animation-name: fadeIn;
        animation-duration: 0.3s
    }

    .errorBanner {
        border: 4px solid red;
        background-color: darkred;
    }

    .successBanner {
        border: 4px solid darkseagreen;
        background-color: green;
    }

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    @-webkit-keyframes fadeIn {
        0% {
            opacity: 0;
        }

        100% {
            opacity: 1;
        }
    }

    .fadeOut {
        animation: fadeOut 0.6s;
        -webkit-animation: fadeOut 0.6s;
    }

    @keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }
</style>